<!--
 * @Descripttion: 
 * @version: 
 * @Author: wb
 * @Date: 2024-02-29 10:54:21
 * @LastEditTime: 2024-02-29 16:02:28
-->
<template>
  <div style="text-align:left">
    <div class="item" v-for="(item,ind) in currList" :key="ind" draggable="true" :data-index="ind" @dragstart.stop="dragstart($event,currList)" @dragenter.stop="dragenter" @dragover="dragover" @dragend="dragend($event,changeSort)">
      <slot :module="item">{{item}}</slot>
    </div>
  </div>
</template> 

<script setup>
import { ref, defineProps, watch, defineEmits } from "vue"
const emit = defineEmits(["on-darg"])

const props = defineProps({
  dataList: {
    type: Array
  }
})

const currList = ref([])
const startIndex = ref('')
const enterIndex = ref('')

watch(() => props.dataList,
  newV => {
    currList.value = newV
  },
  { deep: true, immediate: true, }
)

const dragstart = (e, list) => {
  currList.value = list;
  startIndex.value = e.target.getAttribute('data-index') || e.target.parentNode.getAttribute('data-index');
}
const dragenter = (e) => {
  enterIndex.value = e.target.getAttribute('data-index') || e.target.parentNode.getAttribute('data-index');
}
const dragover = () => {
  // console.log('object 66666666:>> ', e);
}
const dragend = (e, callback) => {
  enterIndex.value = Number(enterIndex.value)
  startIndex.value = Number(startIndex.value)
  // 交换位置
  // currList[enterIndex] = currList.splice(startIndex, 1, currList[enterIndex])[0];
  // 按顺序排序

  if (enterIndex.value < startIndex.value) { // 拖动图片到前面
    currList.value.splice(enterIndex.value, 0, currList.value[startIndex.value]);
    currList.value.splice(Number(startIndex.value) + 1, 1);
  } else { // 拖动图片到后面
    currList.value.splice(Number(enterIndex.value) + 1, 0, currList.value[startIndex.value]);
    currList.value.splice(Number(startIndex.value), 1);
  }
  startIndex.value = '';
  e.preventDefault(); // 设置为可以被拖放
  if (callback) {
    callback();
  }
}
const changeSort = () => {
  emit('on-darg', currList.value)
}

</script>

<style >
.item {
  display: inline-block;
  width: 23%;
  margin: 1%;
  background-color: aqua;
  cursor: move;
}
</style>